import ApiClient from '@/services/apiClient';
import Delay from '@/models/delay';
import AlarmOutput from './alarmOutput';

export default class Alarm {
    enable = false;
    user_repetition = 2;
    repetition_delay = 10;
    output;
    activation_delay = new Delay();
    deactivate_at_first_accepted_user = false;
  
    static constructFromObject(data, obj) {
      obj = obj || new Alarm();
      if(data) {
        obj.enable = true;
        if (Object.prototype.hasOwnProperty.call(data, 'enable'))
          obj.enable = ApiClient.convertToType(data['enable'], 'Boolean');
        obj.user_repetition = ApiClient.convertToType(data['user_repetition'], 'Integer');
        obj.repetition_delay = ApiClient.convertToType(data['repetition_delay'], 'Integer');
        obj.output = AlarmOutput.constructFromObject(data['output']);
        obj.activation_delay = Delay.constructFromObject(data['activation_delay']);
        obj.deactivate_at_first_accepted_user = ApiClient.convertToType(data['deactivate_at_first_accepted_user'], 'Boolean');
      }
      return obj;
    }

    toJSON() {
      const json = {
        user_repetition: this.user_repetition,
        repetition_delay: this.repetition_delay,
        output: this.output,
        deactivate_at_first_accepted_user: this.deactivate_at_first_accepted_user,
      };
      if(this.activation_delay.value > 0) {
        json.activation_delay = this.activation_delay;
      }
      return json;
    }
}
  